const { COOKIES_LIST, CONSENT_CATEGORIES } = require('./constants');

const getNonEssentialValuesOf = (cookieName) => {
  const cookie = COOKIES_LIST.find((item) => item.name === cookieName);

  if (!cookie || !cookie.permissions) {
    return [];
  }

  return Object.keys(cookie.permissions)
    .filter((value) => cookie.permissions[value] !== CONSENT_CATEGORIES.essential);
};

const getSanitizableCookies = () => COOKIES_LIST.filter((cookie) => cookie.sanitizer);

const getNonEssentialCookies = () => COOKIES_LIST
  .filter((cookie) => cookie.permission !== CONSENT_CATEGORIES.essential);

module.exports = {
  getNonEssentialValuesOf,
  getNonEssentialCookies,
  getSanitizableCookies,
};
